/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Intelligence_CenterInputs */

const en_intelligence_center = /** @type {(inputs: Intelligence_CenterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Intelligence Center`)
};

const id_intelligence_center = /** @type {(inputs: Intelligence_CenterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pusat Kecerdasan`)
};

/** @type {(inputs: Intelligence_CenterInputs) => LocalizedString} */
const es_intelligence_center = en_intelligence_center;

/** @type {(inputs: Intelligence_CenterInputs) => LocalizedString} */
const fr_intelligence_center = en_intelligence_center;

/** @type {(inputs: Intelligence_CenterInputs) => LocalizedString} */
const de_intelligence_center = en_intelligence_center;

/** @type {(inputs: Intelligence_CenterInputs) => LocalizedString} */
const ja_intelligence_center = en_intelligence_center;

/** @type {(inputs: Intelligence_CenterInputs) => LocalizedString} */
const zh_intelligence_center = en_intelligence_center;

/** @type {(inputs: Intelligence_CenterInputs) => LocalizedString} */
const ar_intelligence_center = en_intelligence_center;

/** @type {(inputs: Intelligence_CenterInputs) => LocalizedString} */
const it_intelligence_center = en_intelligence_center;

/** @type {(inputs: Intelligence_CenterInputs) => LocalizedString} */
const ru_intelligence_center = en_intelligence_center;

/** @type {(inputs: Intelligence_CenterInputs) => LocalizedString} */
const pt_intelligence_center = en_intelligence_center;

/** @type {(inputs: Intelligence_CenterInputs) => LocalizedString} */
const ko_intelligence_center = en_intelligence_center;

/**
* | output |
* | --- |
* | "Intelligence Center" |
*
* @param {Intelligence_CenterInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const intelligence_center = /** @type {((inputs?: Intelligence_CenterInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Intelligence_CenterInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_intelligence_center(inputs)
	if (locale === "es") return es_intelligence_center(inputs)
	if (locale === "fr") return fr_intelligence_center(inputs)
	if (locale === "de") return de_intelligence_center(inputs)
	if (locale === "ja") return ja_intelligence_center(inputs)
	if (locale === "zh") return zh_intelligence_center(inputs)
	if (locale === "ar") return ar_intelligence_center(inputs)
	if (locale === "id") return id_intelligence_center(inputs)
	if (locale === "it") return it_intelligence_center(inputs)
	if (locale === "ru") return ru_intelligence_center(inputs)
	if (locale === "pt") return pt_intelligence_center(inputs)
	return ko_intelligence_center(inputs)
});